import Loadable from 'react-loadable'
import LoadingPage from 'views/LoadingPage'

export const CodiRowActions = Object.freeze({
  SHOW_INDEXES_MODAL: 'show-indexes-modal',
  SHOW_COMMENTS_MODAL: 'show-comments-modal',
  SHOW_SETTINGS_MODAL: 'show-settings-modal',
  SHOW_AMENDMENT_MODAL: 'show-amendment-modal',
  SHOW_INSTRUCTION_MODAL: 'show-instruction-modal',
  SHOW_REPLACEMENT_MODAL: 'show-replacement-modal',
  SHOW_LINKED_ARTICLES_MODAL: 'show-linked-articles-modal',
  SHOW_LINKED_DOCUMENTS_MODAL: 'show-linked-documents-modal',
  SHOW_LINKED_CODI_DOCUMENTS_MODAL: 'show-linked-codi-documents-modal',
  SHOW_INFO_MODAL: 'show-info-modal',
})

export const CDActionTypes = Object.freeze({
  ROW_CLICKED: 'row-clicked',
  EDIT_CONTENT: 'edit-content',
  AMEND_CONTENT: 'amend-content',
  ADD_CONTENT: 'add-content',
  INSERT_CONTENT: 'insert-content',
  CANCEL_CONTENT: 'cancel-content',
  DELETE_CONTENT: 'delete-content',
  ARRANGE_CONTENT: 'arrange-content',
  SHOW_INFO_MODAL: 'show-info-modal',
  SHOW_KEYWORD_MODAL: 'show-keyword-modal',
  UPDATE_CODI_ROW_TYPE: 'update-codi-row-type',
  SHOW_ADMIN_MODAL: 'show-admin-modal',
  SHOW_DETAIL_MODAL: 'show-detail-modal',
  SHOW_COMMENT_MODAL: 'show-comment-modal',
  SHOW_INDEXES_MODAL: 'show-indexes-modal',
  SHOW_LINKED_ARTICLES_MODAL: 'show-linked-articles-modal',
  SHOW_LINKED_DOCUMENTS_MODAL: 'show-linked-documents-modal',
  SHOW_LINKED_CODI_DOCUMENTS_MODAL: 'show-linked-codi-documents-modal',
  SHOW_LINKED_PRECEDENT_DOCUMENTS_MODAL:
    'show-linked-precedent-documents-modal',
})

export const static_documents = {
  precedent: {
    idname: 'document_type_precedent',
    id: '731d14c5-c7d4-11ed-97ad-72b69ee8bafb',
    label: 'precedent'
  },
  judgment: {
    idname: 'document_type_judgment',
    id: '451ce557-4cbe-11ee-974a-72b69ee8bafb',
    label: 'judgment'
  },
}

export default Loadable({
  loader: () => import('./DocumentsPage'),
  loading: LoadingPage,
})
